<template>
    <div>
        <container :active_path="'/invest/foreclosure'" :plate="'投资军团'">
            <div class="base-warp">
                <div class="head">
                    <el-row>
                        <el-col :span="12">
                            <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                                <el-form-item label="名称">
                                    <el-input v-model="form.keyword"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="onsearch" icon="el-icon-search">搜索</el-button>
                                    <el-button type="success" @click="showadd" icon="el-icon-plus">添加房源</el-button>
                                </el-form-item>
                            </el-form>
                            
                        </el-col>
                        <el-col :span="12">
                             <el-button-group class="float-right">
                                <el-button type="primary" plain size="mini" icon='el-icon-edit'>编辑</el-button>
                                <el-button type="danger" size="mini" icon='el-icon-delete'>删除</el-button>
                                <el-button type="success" size="mini" icon='el-icon-upload2'>上架</el-button>
                                <el-button type="warning" size="mini" icon='el-icon-download'>下架</el-button>
                            </el-button-group>
                        </el-col>
                    </el-row>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="名称" prop="name" show-overflow-tooltip></el-table-column>
                        <el-table-column label="地址" prop="title" show-overflow-tooltip>
                            <template slot-scope="s">
                                <p class="text">{{s.row.location.address}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="区域" prop="region" width="100"></el-table-column>
                        <el-table-column label="拍卖阶段" prop="stage" width="100"></el-table-column>
                        <el-table-column label="起拍价" prop="start_price" width="80" align="center"></el-table-column>
                        <el-table-column label="当前价格" prop="current_price" width="80" align="center"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="s">
                                <el-button-group >
                                    <el-button type="primary" plain size="mini" icon='el-icon-edit' @click="editbaseinfo(s.row)"></el-button>
                                    <el-button type="danger" size="mini" icon='el-icon-delete' @click="deletehouse(s.row)"></el-button>
                                    <el-button v-if="!s.row.putaway" type="success" size="mini" icon='el-icon-upload2'  @click="setputaway(s.row, true)"></el-button>
                                    <el-button v-else type="warning" size="mini" icon='el-icon-download'  @click="setputaway(s.row, false)"></el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import container from '../../../components/container.vue' 
export default {
    components: {
        container,
    },
    data() {
        return {
            form: {
                keyword: '',
                region: '',
                stage: '',
                pricerange: '',
            },
            pageNo: 1,
            pagesize: 15,
            total: 0,
            tabledata: [],
        }
    },
    mounted () {
        this.gettabledata();
    },
    methods: {
        setputaway(item, putaway) {
            var params = {
                id: item._id['$oid'],
                putaway,
            }
            this.$api.foreclosureputaway(params)
                .then(data=>{
                    this.$message.success(data);
                    this.gettabledata();
                })
        },
        deletehouse(item) {
            this.$confirm('是否确定删除这个房源').then(
                confirm=>{
                    var params = {
                        id: item._id['$oid']
                    }
                    this.$api.foreclosuredelete(params)
                        .then(data=>{
                            this.$message.success(data);
                            this.gettabledata();
                        })
                }
            )
                
        },
        onsearch() {
            this.pageNo = 0;
            this.gettabledata();
        },
        showadd() {
            this.$router.push({path: '/invest/foreclosure/edit'});
        },
        gettabledata() {
            var params = {
                keyword: this.form.keyword,
                region: this.form.region,
                stage: this.form.stage,
                pricerange: this.form.pricerange,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getforeclosurelist(params)
                .then(data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                })
        },
        currentChange(page) {
            this.pageNo = page;
            this.gettabledata();
        },
        editbaseinfo(item) {
            var id = item._id['$oid'];
            this.$router.push({path: '/invest/foreclosure/detail', query:{id}});
        },
    },
}
</script>

<style lang="scss" scoped>
.float-right{
    float: right;
}
</style>